import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo, forwardRef, useContext } from 'react';
import _Icon from '../../components/Icon/index.js';
import _Link from '../../components/Link/index.js';
import { DropdownContext } from './DropdownContext.js';

var _excluded = ["buttonTextColor", "buttonTextSize", "renderButton"];
var _templateObject, _templateObject2;
var StyledIcon = styled(_Icon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 1.5rem;\n"])));
var StyledDropdownButton = styled(_Link)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  &:hover,\n  &:focus {\n    color: ", ";\n    text-decoration: underline;\n    outline: none;\n\n    & * {\n      color: ", ";\n      text-decoration: underline;\n      outline: none;\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.secondary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.secondary;
});
var handleKeyInput = function handleKeyInput(navigateToSubMenuItems, setIsOpen) {
  return function (e) {
    var keycode = e.which || e.charCode || e.keyCode;
    switch (keycode) {
      case 13: // enter
      case 32: // space
      case 39:
        // right arrow
        e.preventDefault();
        setIsOpen(true);
        break;
      case 27:
        // escape
        setIsOpen(false);
      case 37:
        // left arrow
        e.preventDefault();
        setIsOpen(false);
        break;
      case 40:
        // down arrow
        e.preventDefault();
        navigateToSubMenuItems();
        break;
    }
  };
};
var DropdownButton = function DropdownButton(_ref3, ref) {
  var _ref3$buttonTextColor = _ref3.buttonTextColor,
    buttonTextColor = _ref3$buttonTextColor === void 0 ? 'black' : _ref3$buttonTextColor,
    _ref3$buttonTextSize = _ref3.buttonTextSize,
    buttonTextSize = _ref3$buttonTextSize === void 0 ? 'medium' : _ref3$buttonTextSize,
    RenderButton = _ref3.renderButton,
    rest = _objectWithoutProperties(_ref3, _excluded);
  var _useContext = useContext(DropdownContext),
    buttonText = _useContext.buttonText,
    isOpen = _useContext.isOpen,
    navigateToSubMenuItems = _useContext.navigateToSubMenuItems,
    setIsOpen = _useContext.setIsOpen,
    theme = _useContext.theme,
    toggleMenu = _useContext.toggleMenu;
  return /*#__PURE__*/React.createElement(StyledDropdownButton, _extends({
    "aria-haspopup": true,
    "aria-expanded": isOpen
    // @ts-ignore
    ,
    color: buttonTextColor,
    onClick: toggleMenu,
    onKeyDown: handleKeyInput(navigateToSubMenuItems, setIsOpen),
    role: 'menuitem',
    size: buttonTextSize,
    tabIndex: 0,
    theme: theme,
    ref: ref,
    "data-testid": 'dropdown-button'
  }, rest), /*#__PURE__*/React.createElement("strong", null, !!RenderButton ? /*#__PURE__*/React.createElement(RenderButton, {
    isOpen: isOpen,
    theme: theme
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, buttonText, /*#__PURE__*/React.createElement(StyledIcon, {
    name: isOpen ? 'caret-up' : 'caret-down',
    size: buttonTextSize === 'medium' ? 'xs' : 'small',
    color: buttonTextColor
  }))));
};
var DropdownButton$1 = /*#__PURE__*/memo(/*#__PURE__*/forwardRef(DropdownButton));

export default DropdownButton$1;
export { DropdownButton };
